import { httpWithAuth } from '~/clients';
import { INVENTORY } from '~/constants/endpoints';
import { InventoryRequest, InventoryResponse } from './contracts';

const fetchInventory = (
  request: InventoryRequest,
  controller: AbortController
) =>
  httpWithAuth.post<InventoryResponse>(INVENTORY, request, {
    signal: controller.signal
  });

export default fetchInventory;
